import type React from 'react'
import './SubscriptionCardNotice.scss'

const types = {
  ALERT: 'alert',
  ACTION_REQUIRED: 'action-required',
}

const cssVars = {
  [types.ALERT]: 'subscription-alert',
  [types.ACTION_REQUIRED]: 'subscription-failed',
}

type SubscriptionCardNoticeProps = {
  type?: string
  backgroundColor?: string
  textColor?: string
  theme?: string
  children: React.ReactNode
}

export const SubscriptionCardNotice: React.FC<SubscriptionCardNoticeProps> = ({
  type = types.ALERT,
  theme = '',
  children,
}) => {
  const style = cssVars[type]

  return (
    <div
      className={`c-subscription-card-notice ${
        theme ? `theme-${theme}` : style
      }`}
    >
      <p className="c-subscription-card-notice__text type-body">{children}</p>
    </div>
  )
}
